import { FormState, useFormState } from 'react-hook-form'
import { InstallationFormModel } from '../../installation/forms'
import { useInstallationForm } from '../../installation/hooks'
import { checkTrueRecursively, hasFieldError } from '../../utils'

type DirtyFields = FormState<InstallationFormModel>['dirtyFields']
type Errors = FormState<InstallationFormModel>['errors']

/**
 * Computes the dirty and error state of a form section (accordion) from one or more form subtrees.
 *
 * A single section can map to several non-contiguous form subtrees (e.g. the Tariffs accordion),
 * so both selectors return an array of subtrees that are OR-ed together.
 */
export const useSectionFormStatus = (
  selectDirtySubtrees: (dirtyFields: DirtyFields) => unknown[],
  selectErrorSubtrees: (errors: Errors) => unknown[]
): { isDirty: boolean; isError: boolean } => {
  const { control } = useInstallationForm()
  const { dirtyFields, errors } = useFormState({ control })

  return {
    isDirty: selectDirtySubtrees(dirtyFields).some(checkTrueRecursively),
    isError: selectErrorSubtrees(errors).some(hasFieldError),
  }
}
